module.exports = __webpack_public_path__ + "static/media/Item_Row_Purple@3x.b4b5bd62.png";